import React from 'react'
import "./Lan.css"
import img1 from "../../assets/Movie1.png" 
import { Link } from 'react-router-dom'
import {HiLocationMarker} from "react-icons/hi"
import pdfLink from "../../assets/Rules.pdf"
import img2 from "../../assets/Pubg.jpeg"
import img3 from "../../assets/Valorant.jpeg"
const Lan = () => {
  return (
    <div className='Lan_container'>
        <div className="title">
            <h2>LAN GAMING</h2>            
        </div>
        <div className="evt_data">
            <div className="left">
                {/* <img src={img1} alt="" /> */}
            </div>
            <div className="right">
                <div className="r_detail">
                <p>Mar 14,2023</p>
                <h2>GAMING COMPETITION  (Team)</h2>
                </div>
                <div className="reg_data">
                    <div className="flex-cont">
                <div className="evt_reg">
                    <h2>Entry Fee : Rs. 100</h2>
                    <div className="reg_btns">
                    <Link to="" target="_blank" className="reg_btn">Register Now</Link>
                    </div>
                    </div>
                </div>
                <div className="desc">
                    <h3>Description</h3>
                     <p>The LAN gaming event nvolves multiple players connecting their computers or gaming consoles together using a local network. This allows players to compete against each other in multiplayer games in real-time, without the lag or latency issues that can occur when playing online. gaming events can be a great way for players to socialize and compete with others who share their passion for gaming. They often create a sense of community among participants and can even lead to new friendships or professional opportunities in the gaming industry.</p>
                     {/* <Link to={pdfLink} target="_blank" className="reg_btn">Rules & Regulations</Link> */}
                     <img src={img2} alt="" />
                     <img src={img3} alt="" />
                </div>
                <div className="date">
                    <h3>Date & Time</h3>
                    <div className="date_data">
                        <h4>Mar 14,2023</h4>
                    </div>
                </div>
                <div className="loc">
                    <h3>Location</h3>
                    <p> <HiLocationMarker/>College of Engineering and Technology,Akola</p>
                </div>
                <div className="team">
                    <h3><span>Coordinator</span> Team</h3>
                    <div className="staf_team">
                        <h4>Staff Co-ordinator</h4>
                        <p>Kalyani Gawande : +91 91467 95180</p>
                    </div>
                    <div className="team_data">
                        <h4>Student Co-ordinator</h4>
                        <p>Yashsingh Thakur : +91 76202 83583</p>
                        <p>Sumeet Solanki : +91 86685 20501</p>
                        <p>Riddhish Joshi : +91 84119 89808</p>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Lan